'use client';

import { clsx } from 'clsx';
import createSvg from '~/public/static/svg/createSvg';

export const CheckmarkIcon = createSvg(({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('h-6 w-6', className)}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  </svg>
));
